// Push notification broadcast to all registered devices.

import React, { useState } from 'react';
import { broadcastNotification } from '../../services/adminService';
import ConfirmDialog from '../common/ConfirmDialog';
import Field from '../common/Field';

export default function AdminBroadcast() {
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [error, setError] = useState('');

  const send = async () => {
    setConfirm(false);
    setBusy(true);
    setError('');
    setResult(null);
    try {
      const res = await broadcastNotification(title, body);
      setResult(res);
    } catch (e) {
      setError(e?.response?.data?.error || e.message);
    } finally { setBusy(false); }
  };

  return (
    <>
      <div className="portal-content-header">
        <h1>Push broadcast</h1>
      </div>

      <div className="portal-card" style={{ maxWidth: 640 }}>
        <p style={{ marginTop: 0, color: 'var(--tudu-text-mid)' }}>
          Sends a notification to every registered device. Use sparingly — there's no
          targeting or scheduling yet.
        </p>
        <div className="portal-form-grid">
          <Field label="Title" full>
            <input className="portal-search" value={title} onChange={e => setTitle(e.target.value)} />
          </Field>
          <Field label="Body" full>
            <textarea className="portal-textarea" value={body} onChange={e => setBody(e.target.value)} />
          </Field>
        </div>
        {error && <div className="portal-error" style={{ marginTop: 'var(--tudu-space-3)' }}>{error}</div>}
        {result && (
          <div className="portal-success" style={{ marginTop: 'var(--tudu-space-3)' }}>
            Sent to {result.sent_to} device{result.sent_to === 1 ? '' : 's'}.
          </div>
        )}
        <div style={{ marginTop: 'var(--tudu-space-4)' }}>
          <button type="button" className="portal-button" disabled={busy || !title || !body} onClick={() => setConfirm(true)}>
            {busy ? 'Sending…' : 'Send to all users'}
          </button>
        </div>
      </div>

      <ConfirmDialog
        open={confirm}
        title="Broadcast to every user?"
        message={`"${title}" — ${body}`}
        confirmLabel="Send"
        onConfirm={send}
        onCancel={() => setConfirm(false)}
      />
    </>
  );
}
